import { REQUIREMENT_COMPETENCY_TYPE } from "./CreateAndEdit/constants";
import { REQUIREMENT } from "../../helpers/constants";
import {
  formatSkillLevelLabel,
  resolveEvaluationMetricLabel,
} from "helpers/customLabels";
import { CustomLabel, CustomLabelType } from "types/CustomLabel";

export const REQUIREMENT_TYPE = [
  { value: REQUIREMENT_COMPETENCY_TYPE.EPA, label: "EPA" },
  { value: REQUIREMENT_COMPETENCY_TYPE.DOP, label: "DOP" },
];
export const LEVEL_COMPETENCY = [
  { value: "1", label: "Pre-novice 1" },
  { value: "2", label: "Pre-novice 2" },
  { value: "3", label: "Novice" },
  { value: "4", label: "Advanced beginner" },
  { value: "5", label: "Competent" },
  { value: "6", label: "Proficient" },
];

export const LEVEL_EPA = [
  { value: "1", label: "1 Direct supervision" },
  { value: "2", label: "2 Indirect supervision" },
  { value: "3", label: "3 Distant supervision" },
  { value: "4", label: "4 On-demand supervision" },
  { value: "5", label: "5 I can supervise others" },
];

export const getLevelObject = (type: string | null) => {
  if (type === REQUIREMENT.REQUIREMENT_EPA) {
    return LEVEL_EPA;
  } else {
    return LEVEL_COMPETENCY;
  }
};

export const LEVEL_COMPETENCY_OBJ = [
  "Pre-novice 1",
  "Pre-novice 2",
  "Novice",
  "Advanced beginner",
  "Competent",
  "Proficient",
];

export const LEVEL_EPA_OBJ = [
  "1 Direct supervision",
  "2 Indirect supervision",
  "3 Distant supervision",
  "4 On-demand supervision",
  "5 I can supervise others",
];

export const getLabelLevel = (
  type: string | null,
  index: number,
  customLabels: CustomLabel[] = [],
  metricLabel?: string | null,
) => {
  let orgLabel: string | undefined;
  if (customLabels.length > 0) {
    const typeKey =
      type === REQUIREMENT.REQUIREMENT_EPA
        ? CustomLabelType.SKILL_LEVEL_SCORE_EPA
        : CustomLabelType.SKILL_LEVEL_SCORE_COMPETENCY;

    const scoped = customLabels.filter((c) => c.type === typeKey);
    orgLabel = scoped.find((c) => c.index === index)?.label;
  }
  const defaultLabel =
    type === REQUIREMENT.REQUIREMENT_EPA
      ? LEVEL_EPA_OBJ[index - 1]
      : LEVEL_COMPETENCY_OBJ[index - 1];

  return formatSkillLevelLabel(
    index,
    resolveEvaluationMetricLabel(metricLabel, orgLabel, defaultLabel),
  );
};

export const ANIMAL_SIZE = [
  { value: "any", label: "Any" },
  { value: "small animal", label: "Small Animal" },
  { value: "medium animal", label: "Medium Animal" },
  { value: "big animal", label: "Big Animal" },
];
